module.exports = __webpack_public_path__ + "media/images/watch/mobile-study-tools-29cb2ca23181aabe90b084e0d520a1b1.png";